module.exports = __webpack_public_path__ + "img/P150T_weapon_132.72f3d98a.png";